import CreateProperty from './CreateProperty';

export default CreateProperty;
